export enum UploadProgress {
  Start = 0,
  Complete = 100
}
